// This files runs at the very beginning (even before React and Next.js core)

// import 'polyfill here';

if (process.env.NODE_ENV === 'development' && typeof window === 'object') {
    require('@webcomponents/shadydom');
}
